import React from "react";
import { useNavigate } from "react-router-dom";
import ReportsTable from "./ReportsTable";

const TransactionsReportTable = ({ reportData, onBack, reportType, dateRange, branch }) => {
  const navigate = useNavigate();

  const columns = [
    { 
      header: "Reservation ID", 
      accessor: "reservationId",
      render: (row) => {
        if (!row.reservationId) return "";
        return (
          <button
            onClick={() => navigate(`/reservations/${row.reservationId}`)}
            className="text-blue-600 hover:text-blue-800 font-medium hover:underline transition-colors cursor-pointer"
          >
            {row.reservationId}
          </button>
        );
      }
    },
    { header: "Reservation Code", accessor: "reservationCode" },
    { header: "Reference", accessor: "reference" },
    { header: "Status", accessor: "status" },
    { header: "Invoice / Bill Number", accessor: "invoiceNumber" },
    { 
      header: "Customer", 
      accessor: "customer",
      render: (row) => {
        if (!row.customer) return "";
        const customerId = row.customerId;
        if (customerId) {
          return (
            <button
              onClick={() => navigate(`/customers/${customerId}`)}
              className="text-blue-600 hover:text-blue-800 font-medium hover:underline transition-colors cursor-pointer"
            >
              {row.customer}
            </button>
          );
        }
        return (
          <button
            onClick={() => navigate(`/customers`)}
            className="text-blue-600 hover:text-blue-800 font-medium hover:underline transition-colors cursor-pointer"
          >
            {row.customer}
          </button>
        );
      }
    },
    { 
      header: "Class", 
      accessor: "class",
      render: (row) => {
        if (!row.class) return "";
        const vehicleId = row.vehicleId;
        if (vehicleId) {
          return (
            <button
              onClick={() => navigate(`/vehicles/${vehicleId}`)}
              className="text-blue-600 hover:text-blue-800 font-medium hover:underline transition-colors cursor-pointer"
            >
              {row.class}
            </button>
          );
        }
        return (
          <button
            onClick={() => navigate(`/vehicles`)}
            className="text-blue-600 hover:text-blue-800 font-medium hover:underline transition-colors cursor-pointer"
          >
            {row.class}
          </button>
        );
      }
    },
    { header: "Currency Code", accessor: "currencyCode" },
    { header: "Balance", accessor: "balance" },
    { header: "Security Deposit", accessor: "securityDeposit" },
    { header: "Deposit Balance", accessor: "depositBalance" },
    { header: "Transaction Date Created", accessor: "transactionDateCreated" },
    { header: "Transaction Type", accessor: "transactionType" },
    { header: "Transaction Method", accessor: "transactionMethod" },
    { header: "Transaction Amount", accessor: "transactionAmount" },
  ];

  // Default client-side sort by reservationId desc as a safety net
  const sortedData = {
    ...reportData,
    rows: Array.isArray(reportData?.rows)
      ? [...reportData.rows].sort((a, b) => {
          const ida = Number.isFinite(Number(a?.reservationId)) ? Number(a.reservationId) : -Infinity;
          const idb = Number.isFinite(Number(b?.reservationId)) ? Number(b.reservationId) : -Infinity;
          return idb - ida;
        })
      : []
  };

  return (
    <ReportsTable
      title={reportType === "transactions" ? "Transactions Report" : "Report"}
      branch={branch}
      dateRange={dateRange}
      reportData={sortedData}
      columns={columns}
      exportEndpoint="/api/reports/transactions"
      onBack={onBack}
      emptyStateSubtitle="No transactions found for the selected criteria."
    />
  );
};

export default TransactionsReportTable; 